/**
 * Cart Limits & Slots - Controls add-to-cart limits and cart drawer slots.
 *
 * Rules:
 * - product_type "Eyeglasses" = optical (max 3 in cart)
 * - Other product_type = sunglasses (max 1 in cart)
 * - Same product can only be added once
 *
 * Slots:
 * - 4 fixed slots in cart drawer (1 sun + 3 optical)
 * - Filled in order of arrival
 * - Sun slot reserved for sun products, shifts if optical added first
 */

(function() {
  var EYEGLASSES_TYPE = 'Eyeglasses';
  var MAX_OPTICAL = 3;
  var MAX_SUN = 1;

  var cartItems = [];

  function getCartProductIds() {
    return cartItems.map(function(item) { return item.product_id; });
  }

  function countByType() {
    var optical = 0;
    var sun = 0;
    cartItems.forEach(function(item) {
      if (item.product_type === EYEGLASSES_TYPE) {
        optical++;
      } else {
        sun++;
      }
    });
    return { optical: optical, sun: sun };
  }

  function isProductInCart(productId) {
    return getCartProductIds().indexOf(Number(productId)) !== -1;
  }

  function canAddProduct(productType) {
    var counts = countByType();
    if (productType === EYEGLASSES_TYPE) {
      return counts.optical < MAX_OPTICAL;
    }
    return counts.sun < MAX_SUN;
  }

  function updateButtons() {
    var buttons = document.querySelectorAll(
      '.ff-product-card__atc-button[data-product-id], .ff-pdp-atc-button[data-product-id]'
    );
    buttons.forEach(function(btn) {
      var productId = btn.dataset.productId;
      if (!productId) return;
      btn.dataset.ffInCart = isProductInCart(productId) ? 'true' : 'false';
      btn.dataset.ffCanAdd = canAddProduct(btn.dataset.productType || '') ? 'true' : 'false';
    });
  }

  /* ========== SLOTS ========== */

  function getSunPlaceholder() {
    var el = document.querySelector('[data-slot-type="sun"] .ff-cart-drawer-slot-placeholder');
    if (!el) el = document.querySelector('[data-slot-type="sun"] .ff-cart-slot__placeholder-text');
    return el ? el.textContent.trim() : 'You can add another sunglass frame to try';
  }

  function getOpticalPlaceholder() {
    var el = document.querySelector('[data-slot-type="optical"] .ff-cart-drawer-slot-placeholder');
    if (!el) el = document.querySelector('[data-slot-type="optical"] .ff-cart-slot__placeholder-text');
    return el ? el.textContent.trim() : 'You can add another optical frame to try on';
  }

  function buildSlotHTML(item) {
    var imgUrl = '';
    if (item.image) {
      imgUrl = item.image.replace(/(\?|&)width=\d+/, '') + '?width=200';
    }
    return '<div class="ff-cart-slot__product">' +
      '<a href="' + item.url + '" class="ff-cart-slot__image ff-media-wrapper ff-cart-drawer--item-image">' +
        '<img src="' + imgUrl + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" class="ff-image-snippet">' +
      '</a>' +
      '<div class="ff-cart-slot__info">' +
        '<a href="' + item.url + '" class="ff-cart-slot__title ff-snippet-text ff-cart-drawer--item-title">' + item.product_title + '</a>' +
        '<span class="ff-cart-slot__sku ff-snippet-text ff-cart-drawer--item-sku">' + (window.ffCartRefLabel || 'Ref.') + ' ' + (item.sku || '') + '</span>' +
      '</div>' +
      '<button class="ff-cart-slot__remove" data-line-key="' + item.key + '" aria-label="Remove" type="button">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="square"/><path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>' +
      '</button>' +
    '</div>';
  }

  function buildPlaceholderHTML(type) {
    var text = type === 'sun' ? getSunPlaceholder() : getOpticalPlaceholder();
    return '<div class="ff-cart-slot__placeholder">' +
      '<div class="ff-snippet-text ff-cart-drawer-slot-placeholder futura-pt" data-type="' + type + '">' + text + '</div>' +
    '</div>';
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2) + ' ' + (Shopify && Shopify.currency && Shopify.currency.active || '€');
  }

  function updateSlots() {
    var container = document.getElementById('ff-cart-slots');
    if (!container) return;

    var slots = container.querySelectorAll('.ff-cart-slot');
    if (slots.length === 0) return;

    // Build slot assignments: items in order, then placeholders
    var sunPlaceholder = getSunPlaceholder();
    var opticalPlaceholder = getOpticalPlaceholder();

    // Determine slot types based on cart content
    // Sun slot is first by default, but if all items are optical, sun stays at first empty
    var hasSunInCart = false;
    cartItems.forEach(function(item) {
      if (item.product_type !== EYEGLASSES_TYPE) hasSunInCart = true;
    });

    var slotData = [];
    // Fill with cart items first (max 4)
    for (var i = 0; i < Math.min(cartItems.length, 4); i++) {
      slotData.push({ type: 'filled', item: cartItems[i] });
    }

    // Fill remaining with placeholders
    var counts = countByType();
    var sunSlotPlaced = hasSunInCart || counts.sun >= MAX_SUN;

    for (var j = slotData.length; j < 4; j++) {
      if (!sunSlotPlaced) {
        slotData.push({ type: 'placeholder', slotType: 'sun' });
        sunSlotPlaced = true;
      } else {
        slotData.push({ type: 'placeholder', slotType: 'optical' });
      }
    }

    // Render slots
    slotData.forEach(function(data, idx) {
      var slot = slots[idx];
      if (!slot) return;

      if (data.type === 'filled') {
        slot.className = 'ff-cart-slot ff-cart-slot--filled';
        slot.dataset.slotIndex = idx;
        slot.dataset.lineKey = data.item.key;
        slot.dataset.productId = data.item.product_id;
        slot.dataset.productType = data.item.product_type || '';
        slot.innerHTML = buildSlotHTML(data.item);
      } else {
        slot.className = 'ff-cart-slot ff-cart-slot--empty';
        slot.dataset.slotIndex = idx;
        slot.dataset.slotType = data.slotType;
        delete slot.dataset.lineKey;
        delete slot.dataset.productId;
        delete slot.dataset.productType;
        slot.innerHTML = buildPlaceholderHTML(data.slotType);
      }
    });

    // Attach remove handlers
    container.querySelectorAll('.ff-cart-slot__remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var lineKey = btn.dataset.lineKey;
        if (!lineKey) return;

        btn.disabled = true;

        if (typeof FfCartService !== 'undefined') {
          FfCartService.updateLine(lineKey, 0);
        } else {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          })
          .then(function() {
            fetchCart();
          });
        }
      });
    });
  }

  /* ========== FETCH & INIT ========== */

  function fetchCart() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartItems = cart.items || [];
        updateButtons();
        updateSlots();
      })
      .catch(function(err) {
        console.error('ff-cart-limits: error fetching cart', err);
      });
  }

  // Initial fetch
  fetchCart();

  // Listen for cart updates
  document.addEventListener('cart:updated', function() {
    fetchCart();
  });

  if (typeof FfEvents !== 'undefined' && FfEvents.on) {
    FfEvents.on('cart:updated', function() {
      fetchCart();
    });
  }

  /* ========== POPUP LIMITS ========== */

  var popupTimeout = null;

  function showLimitPopup() {
    var popup = document.getElementById('ff-popup-limits');
    if (!popup) return;
    popup.style.display = 'block';
    clearTimeout(popupTimeout);
    var duration = parseInt(popup.dataset.duration || 5, 10);
    if (duration > 0) {
      popupTimeout = setTimeout(function() {
        popup.style.display = 'none';
      }, duration * 1000);
    }
  }

  // Close button
  document.addEventListener('click', function(e) {
    if (e.target.closest('.ff-popup-limits__close')) {
      var popup = document.getElementById('ff-popup-limits');
      if (popup) popup.style.display = 'none';
      clearTimeout(popupTimeout);
    }
  });

  // Expose for external use
  window.ffCartLimits = {
    refresh: fetchCart,
    isProductInCart: function(id) { return isProductInCart(id); },
    canAddProduct: function(type) { return canAddProduct(type); },
    showLimitPopup: showLimitPopup
  };
})();
